<div class="tenant-modal-overlay"></div>

<div class="tenant-modal-container">
    <div class="tenant-modal-header">
        <h4>{{ header }}</h4>
        <span class="close-icon" (click)="closeModal()">
            <i class="fas fa-xmark"></i>
        </span>
    </div>

    <div class="tenant-modal-content">
        <div class="tenant-option" *ngFor="let tenant of tenants" (click)="selectTenant($event, tenant.tenantId)">
            <i class="fas fa-people-group"></i>
            {{ tenant.tenantName }}
        </div>
    </div>

    <div class="tenant-modal-actions">
        <button type="button" class="button-cancel" (click)="closeModal()">
            Cancel
        </button>
    </div>
</div>